import { store } from '@betacrew/jars-flux';

export const componentKey = "QBD_PLUGIN_SWITCH";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setImportData: (state, action) => {
            state.importData = action.payload;
        },
        setIsImportDataGridViewLoaded: (state, action) => {
            state.isImportDataGridViewLoaded = action.payload;
        },
        setFormSettings: (state, action) => {
            state.formSettings = action.payload;
        },
    },
    initialReducerState: {
        importData: null,
        isImportDataGridViewLoaded: false,
        formSettings: null,
        loadingState: false
    }
});

export const { setLoadingState, setImportData, setIsImportDataGridViewLoaded, setFormSettings } = actions;